import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function MealModal() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button className="btn-outline-light" variant="danger" size='sm' onClick={handleShow}>
        Info
      </Button>

      <Modal show={show} onHide={handleClose} animation={true} size='lg' aria-labelledby='contained-modal-title-vcenter' centered style={{backgroundColor:'black'}}>
        <Modal.Header  style={{backgroundColor:'black', border:"2px solid", borderColor:"#D33D3D"}}>
          <Modal.Title style={{backgroundColor:'black', border:'none', color:'white'}}>One-Time 1-Month Meal Plan</Modal.Title>
        </Modal.Header>
        <Modal.Body  style={{backgroundColor:'black', border:"2px solid", borderColor:"#D33D3D", color:'white'}}>
            <h2>
              <u>                
                Customized Nutrition Plan
              </u>
            </h2>
            <p>
              A full 4-week meal plan tailored to your calorie and macronutrient targets.
            </p>
            <h2>
              <u>                
                Daily Meal Breakdown
              </u>
            </h2>
            <p>
              Recipes with portion sizes, macros, and ingredient lists for every day of the month.
            </p>
            <h2>
              <u>                
                Grocery List
              </u>
            </h2>
            <p>Simplified shopping lists to keep prep easy and cost-efficient.</p>
            <h2>
              <u>                
                Personalization
              </u>
            </h2>
            <p>Designed around your food preferences, allergies, and schedule — with options for snacks, cheat meals, or specific dietary styles (keto, fasting, balanced, etc.).</p>
            
            <p>Perfect for anyone who wants expert-level nutrition structure — this plan gives you the blueprint to take control of your results and build sustainable eating habits that last.</p>
            
            
            <p>Your personalized nutrition journey starts here.</p>
            <h3 className='pt-3'>Train. Eat. Evolve.</h3>
            
        </Modal.Body>
        <Modal.Footer style={{backgroundColor:'black', border:"2px solid", borderColor:"#D33D3D"}}>
          <h5 className='col' style={{color:"white"}}>
            Price: $100.00
          </h5>
          <Button  variant="danger"  onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default MealModal;